import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, trackVisitor } from '../../utils/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    // Initialize Google Analytics on mount
    if (measurementId) {
      initGA(measurementId);
      trackVisitor();
    } else {
      console.warn('Google Analytics Measurement ID is not set. Please add REACT_APP_GA_MEASUREMENT_ID to your .env file');
    }
  }, [measurementId]);

  useEffect(() => {
    // Track page views on route change
    if (measurementId && window.gtag) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, measurementId]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;

